import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarFull } from '../TopBarFull';
import { TopBarFullCtaColors } from '../TopBarFullEnums';
import marketResearchImage from '../assets/UC_Market_Research.png';

const COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseMarketResearchTopBarFull.headline',
    defaultMessage: 'Reach your market from around the globe',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseMarketResearchTopBarFull.message',
    defaultMessage:
      'Gather feedback from a global panel of survey respondents with SurveyMonkey Audience.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseMarketResearchTopBarFull.ctaText',
    defaultMessage: 'BUY RESPONSES',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

export const UseCaseMarketResearchTopBarFull: React.FC = () => {
  return (
    <TopBarFull
      headline={t(COPY.HEADLINE)}
      message={t(COPY.MESSAGE)}
      image={() => <img src={marketResearchImage} aria-hidden="true" />}
      ctaText={t(COPY.CTA_TEXT)}
      ctaLink={createURL('/collect/audience/preview', {
        ut_source: 'topbar',
        ut_source2: 'full_misc_upsell_market_research',
      })}
      ctaNewTab={true}
      ctaColor={TopBarFullCtaColors.alt}
    />
  );
};

export default UseCaseMarketResearchTopBarFull;
